jQuery(document).ready(function($) {
    $(".nav-btn--search").click(function (e) {
        e.preventDefault();
        $('.search-form').fadeToggle("400");
        $(this).addClass('zero-opacity');
    });
    $(".search-form--close").click(function(e){
        e.preventDefault();
        $('.search-form').fadeToggle("400");
        $('.nav-btn--search').removeClass("zero-opacity");
    });

    $("#toggle-apartment-search").click(function(e){
        if($("body").hasClass( "page-template-frontpage" )){
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $('#fp-apartment-search').offset().top -120
            });
            $('#fp-intro-bubble').addClass('hidden');
        } else {
            e.preventDefault();
            $('#header-apartment-search').slideToggle(250);
        }
    });
    $('.application-btn').click(function(){
        var path = window.location.pathname;
        window.dataLayer.push({'event': 'applicationBtnClick', 'address' : path});
    });
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        window.dataLayer.push({
            "event" : "formSubmit",
            "formId" : event.detail.contactFormId,
        })
    });

    $(".galleryPopup").magnificPopup({
        type: "image",

        gallery: {
            // options for gallery
            enabled: true,
            tCounter: "%curr%/%total%" // Markup for "1 of 7" counter
        },
        // other options
        // Delay in milliseconds before popup is removed
        removalDelay: 300,

        // Class that is added to popup wrapper and background
        // make it unique to apply your CSS animations just to this exact popup
        mainClass: "mfp-fade"
    });

    var countdownTimer = document.getElementById("countdownTimer");

    if(countdownTimer) {
        //countdownTimer.innerHTML = '<p>'+countdownTimer.dataset.countdown+'</p>'
        var countDownDate = countdownTimer.dataset.countdown;
        var daysElem = document.getElementById("days");
        var hoursElem = document.getElementById("hours");
        var minutesElem = document.getElementById("minutes");
        var secondsElem = document.getElementById("seconds");

        // Update the count down every 1 second
        const timer = setInterval( checkTimer, 1000);

        checkTimer()

        function checkTimer() {
                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                if (distance < 0) {
                    clearInterval(timer);
                    days = 0;
                    hours = 0;
                    minutes = 0;
                    seconds = 0;
                }


                // Display the result in the element with id="demo"
                daysElem.innerHTML = days;
                hoursElem.innerHTML = hours;
                minutesElem.innerHTML = minutes;
                secondsElem.innerHTML = seconds;

        }

    }

     // info click
 if ( jQuery('#info-container').length ) {
    const info_container = document.getElementById('info-container');

    if ( Cookies.get('info') != 1 ) {
        info_container.classList.add('active');
    }

    jQuery('#info-button, #info-close').on( "click", function() {
        Cookies.set('info', 1);
    });

    if ( info_container ) {
        info_container.addEventListener('click', function (e) {
            if (info_container.classList.contains('active')) {
                info_container.classList.remove('active');
            } else {
                info_container.classList.add('active');
            }
        });
    }
}
 
});